import { ZumperFullDark } from '@zcode-ui/icons'
import { isWithinInterval, parse } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'
import { ZumperStackedHalloween } from './ZumperStackedHalloween/ZumperStackedHalloween'

export const checkDateWithInInterval = ({
  now,
  startDate,
  endDate,
  timezone = 'America/New_York',
}: { now: number; startDate: string; endDate: string; timezone?: string }) => {
  const date = new Date(now)

  const easternDate = utcToZonedTime(date, timezone)

  const parsedStartDate = parse(startDate, 'MM/dd/yyyy', date)
  const parsedEndDate = parse(endDate, 'MM/dd/yyyy', date)

  return isWithinInterval(easternDate, {
    start: parsedStartDate,
    end: parsedEndDate,
  })
}

export const getIsSpookyInterval = (now: number) => {
  const year = new Date(now).getFullYear()
  return checkDateWithInInterval({ now, startDate: `10/31/${year}`, endDate: `11/03/${year}` })
}

export const getHomepageTheme = (now: number) => {
  const homepageTheme: {
    HomepageMobileLogo: typeof ZumperFullDark
    mobileBurgerColor?: string
  } = {
    HomepageMobileLogo: ZumperFullDark,
  }
  const isSpookyInterval = getIsSpookyInterval(now)

  if (isSpookyInterval) {
    homepageTheme.HomepageMobileLogo = ZumperStackedHalloween
    homepageTheme.mobileBurgerColor = '#fff'
  }

  return homepageTheme
}
